import { LogicalOperation, Operator, LinkType, Procedure } from './enums';

export const getAllLogicalOperations = () => {
    return [
        { id: 1, name: LogicalOperation.OR },
        { id: 2, name: LogicalOperation.AND },
        { id: 3, name: LogicalOperation.NOT },
    ];
};

export const getAllTypeSelectors = () => {
    return [
        { name: 'Connector', value: LinkType.CONNECTOR },
        { name: 'Procedure', value: LinkType.PROCEDURE },
    ];
};

export const getAllOperators = () => {
    return [
        { name: 'Equals to', value: Operator.EQ },
        { name: 'Less than', value: Operator.LT },
        { name: 'Greater than', value: Operator.GT },
        { name: 'Less than or Equals to', value: Operator.LTE },
        { name: 'Greater than or Equals to', value: Operator.GTE },
        { name: 'Not Equal to', value: Operator.NTE },
    ];
};

export const getAllProcedures = () => {
    const sharedProcedures = getAllSharedProcedures();
    return [
        { name: 'Assessment', value: Procedure.ASSESSMENT_CODE },
        ...sharedProcedures,
        { name: 'Include/Exclude Active Assessments', value: Procedure.ACTIVE_ONLY_ASSESSMENT },
        { name: 'First Attribute', value: Procedure.FIRST_ATTRIBUTE },
        { name: 'Last Attribute', value: Procedure.LAST_ATTRIBUTE },
        { name: 'User List', value: Procedure.USER_LIST },
    ];
};

export const getAllSharedProcedures = () => {
    return [
        { name: 'Attribute', value: Procedure.ATTRIBUTE },
        { name: 'User Age', value: Procedure.USER_TODAY_AGE },
        { name: 'Assessment Submitted Date', value: Procedure.ASSESSMENT_DATE },
        { name: 'User Age at Assessment Submission', value: Procedure.ASSESSMENT_USER_AGE },
        { name: 'Pass Fail', value: Procedure.PASS_FAIL },
        { name: 'User Profile', value: Procedure.USER_PROFILE },
        { name: 'Include/Exclude Active Attributes', value: Procedure.ACTIVE_ONLY_ATTRIBUTE },
        { name: 'Users without assessment', value: Procedure.WITHOUT_ASSESSMENT_CODE },
    ];
};
